import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postLinkMeAsReferral(referrerLinkId: string) {
    const { apiPostLinkMeAsReferral } = apiConfig.getStaticUrls();

    return postFetch(apiPostLinkMeAsReferral, { referrer_link_id: referrerLinkId });
}
